import { ChangeDetectorRef, Component, effect, OnInit } from '@angular/core';
import { LoginServices } from '../../../../auth/login/services/login.service';
import { ItemsDashboardProfesionalesService } from '../../services/items-dashboard-profesionales.service';
import { TipoAutorizaciones } from 'src/app/shared/interfaces/shared-interface';
import { RegistroProfesionalesService } from '../../services/registro-profesionales.service';
import { DataService } from '../../services/shared/data.service';
import { Param } from 'src/app/shared/interfaces/param-interface';
import { PersonasService } from '../../../../shared/services/personas-service';
import { ProyectoItem } from 'src/app/users/interfaces/proyecto.interface';
import { ProyectoDataService } from 'src/app/users/proyectos/services/proyecto-data.service';
import {
    Ambito,
    Data,
    Proceso,
    ProcesoDetectado,
    Profesion,
} from '../../interfaces/tipos';
import { PersonaInfo } from '../../../../shared/interfaces/shared-interface';
import { Observable, of } from 'rxjs';
import { useEffect } from 'src/utils/useEffect';
import { ShowButtonService } from 'src/utils/services/show-button.service';
import CONSTANTS from 'src/utils/resources/constants';
import { RegistroService } from 'src/app/auth/register/services/registro-service';
import { TipoCatalogo } from 'src/app/users/registro-profesionales/interfaces/tipos';

/**
 * Componente para el dashboard de profesiones
 */
@Component({
    selector: 'dashboard-profesiones',
    templateUrl: './dashboard-profesiones.component.html',
    styleUrls: ['./dashboard-profesiones.component.scss'],
})
export class DashboardProfesionesComponent implements OnInit {
    protected readonly TipoAutorizaciones = TipoAutorizaciones;

    documento: string = '';
    uniqueId?: string;
    resultadoConsulta: string = '';
    infoPersona: any = null;
    usuario: any = null;
    procesoDetectado: any = {
        accion: 'Cargando .... ',
        ambito: 'Cargando .... ',
        title: '',
        imageSrc: '/assets/demo/images/logos/iconos/renovar.png',
        bgColor: 'bg-blue-500',
        routerLink: ['/#'],
        bd_code: 'NINGUNA',
    };

    tiposTramite: any[] = [];
    proyectos: any[] = [];

    procesosDetectados: any[] = [];
    ambientesDisponibles: any[] = [];
    _showLoader: boolean = true;

    data: Data = {
        ambitos: [],
    };
    acciones: string[] = [];
    seleccionAccion: string | null = null;
    resultados: Profesion[] = [];
    resumen: Profesion[] = [];

    categorias: string[] = [];
    ambitos: Ambito[] = [];
    ambitosMenu: Ambito[] = [];
    ambitoActivoId: number | null = null;

    seleccionCategoria: Record<number, string | null> = {};
    profesionesFiltradas: Record<number, Profesion[]> = {};
    seleccionProfesion: Record<number, Profesion | null> = {};

    

    constructor(
        public readonly loginService: LoginServices,
        private readonly itemsService: ItemsDashboardProfesionalesService,
        private readonly registroService: RegistroProfesionalesService,
        private readonly registroServices: RegistroService,
        private readonly dataService: DataService,
        private readonly personasService: PersonasService,
        public proyectoDataService: ProyectoDataService,
        private itemsDashboardProfesionalesService: ItemsDashboardProfesionalesService,
        private cdRef: ChangeDetectorRef,
        private showButtonService: ShowButtonService
    ) {
        useEffect(() => {
            this.proyectos = this.proyectoDataService.itemsPorEstado();
        }, [() => this.proyectoDataService.itemsPorEstado()]);

        useEffect(() => {
            const state = this.showButtonService.currentState();
            if (CONSTANTS.consoleEnabled) {
                console.log('Estado completo:', state);
            }
            if (state.visitado !== null && state.visitado === false) {
                this.showButtonService.changeVisitado(null);
            }
        }, [() => this.showButtonService.currentState()]);
    }

    /**
     * Inicializa el componente
     */
    ngOnInit(): void {
        this.inicializarDatosUsuario()
            .then(() => {
                this.tiposTramite = this.itemsDashboardProfesionalesService.getItemsProfesionales();
                this.proyectoDataService.consultarPorTipoRegProf();
                this.cargarRegistrosProfesionales();
            })
            .catch((error: any) => {
                console.error('Error:', error);
            });

        // Cargar los ámbitos del menú
        this.registroServices.getTiposAmbito().subscribe({
            next: (response) => {
                if (response.body) {
                    this.ambitosMenu = response.body.map((tipo: TipoCatalogo) => ({
                        idAmbito: tipo.idCatalogo,
                        descripcionAmbito: tipo.nombre,
                        clasificaciones: []
                    }));
                }
            },
            error: (error) => {
                console.error('Error al cargar los ámbitos:', error);
            }
        });
        console.log('this.ambitosMenu',this.ambitosMenu);

        const ambitosData = this.data.ambitos;
        this.ambitos = ambitosData;

        for (const a of this.ambitos) {
            this.seleccionCategoria[a.idAmbito] = null;
            this.profesionesFiltradas[a.idAmbito] = [];
            this.seleccionProfesion[a.idAmbito] = null;
        }

        this.ambitoActivoId = this.ambitos.length > 0 ? this.ambitos[0].idAmbito : null;
    }

    /**
     * Carga los registros profesionales
     */
    cargarRegistrosProfesionales() {
        this.proyectoDataService.consultarPorTipoRegProf().add(() => {
            if (this.loginService.hasRoles(['cliente_ventanilla'])) {
                const proyectos =
                    this.proyectoDataService.consultarPorTipoRegProf();
            } else {
                const proyectos =
                    this.proyectoDataService.consultarTodosPorTipoRegProf();
            }
        });

        const allProfesiones = this.data.ambitos.flatMap((a) =>
            a.clasificaciones.flatMap((c) => c.profesiones)
        );
        this.acciones = Array.from(
            new Set(allProfesiones.map((p) => p.accion))
        );
    }

    /**
     * Método que se ejecuta después de que la vista se ha inicializado
     */
    ngAfterViewInit() {
        setTimeout(() => {
            this.cdRef.detectChanges();
        }, 0);
    }

    /**
     * Inicializa los datos del usuario autenticado
     * @returns Promise<void>
     */
    private inicializarDatosUsuario(): Promise<void> {
        return new Promise((resolve, reject) => {
            try {
                const session = this.loginService.session();
                const documento = session?.perfil?.documento;

                this.documento = this.formatearDocumento(documento);
                this.uniqueId = session?.perfil?.uniqueId;
                this.usuario = session?.perfil;

                this.consultarInformacionPersona();
                resolve();
            } catch (error) {
                console.error('Error al inicializar datos del usuario:', error);
            }
        });
    }

    /**
     * Consulta la información de la persona
     */
    private consultarInformacionPersona(): void {
        const documento = this.usuario?.documento;

        if (!documento) return;

        const params: Param[] = [{ key: 'documento', value: documento }];

        this.personasService.consultaInfo(params).subscribe({
            next: (respuesta: any) => {
                this.infoPersona = respuesta.body?.[0] ?? null;
                //console.log('Información de la persona:', this.infoPersona.idTipoPersona);
                this.dataService.setValue('infoPersona', this.infoPersona);
                if (this.infoPersona) {
                    this.consultarProcesoDetectado();
                }
            },
            error: () => {
                // Manejo de errores si es necesario
            },
        });
    }

    data2: any = null;

    /**
     * Consulta el proceso detectado para la persona
     */
    private consultarProcesoDetectado(): void {
        const tipoNacionalidad = this.esExtranjero(this.infoPersona)
            ? 'extranjero'
            : 'nacional';

        this.registroService
            .consultaProceso(tipoNacionalidad, this.documento)
            .subscribe({
                next: (respuesta: any) => {
                    this.data2 = respuesta;
                    this.actualizarDataConData2();
                    this._showLoader = false;
                },
                error: (err) => {
                    console.error('Error al consultar proceso:', err);
                },
            });
    }

    /**
     * Actualiza los datos del componente con la información recibida del servicio
     */
    private actualizarDataConData2(): void {
        this.data = this.data2;
        this.ambitos = this.data.ambitos;
        this.ambitoActivoId = this.ambitos.length
            ? this.ambitos[0].idAmbito
            : null;
        if (this.ambitos.length) {
            this.onAmbitoClick(this.ambitos[0]);
        }
        this.seleccionCategoria = {};
        this.profesionesFiltradas = {};
        this.seleccionProfesion = {};

        for (const a of this.ambitos) {
            this.seleccionCategoria[a.idAmbito] = null;
            this.profesionesFiltradas[a.idAmbito] = [];
            this.seleccionProfesion[a.idAmbito] = null;
        }

        const allProfesiones = this.data.ambitos.flatMap((a) =>
            a.clasificaciones.flatMap((c) => c.profesiones)
        );
        this.acciones = Array.from(
            new Set(allProfesiones.map((p) => p.accion))
        );

        this.cdRef.detectChanges();
    }

    /**
     * Selecciona un proceso
     * @param proceso Proceso a seleccionar
     */
    seleccionarProceso(proceso: any): void {
        this.dataService.setValue('procesoSeleccionado', proceso);
        this.dataService.setValue('ambitoDetectado', proceso.ambito);
    }

    /**
     * Formatea un documento
     * @param documento Documento a formatear
     * @returns Documento formateado
     */
    public formatearDocumento(documento?: string): string {
        if (!documento) return '';
        const soloNumeros = documento.replace(/\D/g, '');
        if (soloNumeros.length !== 9) return documento;

        const parte1 = soloNumeros.slice(0, 8);
        const parte2 = soloNumeros.slice(8);
        return `${parte1}-${parte2}`;
    }

    /**
     * Determina si una persona es extranjera
     * @param persona Información de la persona
     * @returns true si es extranjero, false si no
     */
    esExtranjero(persona: any): boolean {
        const documentos = persona.documentos ?? [];
        const tipoPersona = persona.tipoPersona?.toUpperCase();
        const tieneDUI = documentos.some(
            (doc: { tipo: string }) => doc.tipo === 'DUI'
        );

        if (tipoPersona === 'JURIDICA') return false;
        if (tipoPersona === 'NATURAL') return !tieneDUI;
        return false;
    }

    /**
     * Maneja el evento de click en un item de proyecto
     * @param event Evento con el item seleccionado
     */
    onItemProyectoClicked(event: {
        item: any;
        event: Event;
        operationType: number;
    }) {
        console.log('Proyecto seleccionado:', event.item);
    }

    titleLabel: string = '';

    /**
     * Actualiza la imagen del proceso detectado
     * @param ambito Ámbito del proceso
     * @param tipo Tipo de proceso
     */
    actualizarImagen(ambitoDescripcion: string, ambito: any): void {
        const ambitoKey = ambitoDescripcion.toLowerCase();

        this.procesoDetectado = {
            title:
                this.ambitoTitles[ambitoKey] ||
                `Registro de Profesionales - ${ambitoDescripcion}`,
            imageSrc: this.ambitoImages[ambitoKey] || this.defaultImage,
            bgColor: this.ambitoColors[ambitoKey] || 'bg-blue-500',
        };
        this.labelIniciarTramite = `Complete los datos para ${ambitoDescripcion.toLowerCase()}`;
    }

    /**
     * Actualiza la imagen del proceso detectado (versión alternativa)
     * @param ambito Ámbito del proceso
     * @param tipo Tipo de proceso
     */
    actualizarImagen2(ambito: string, tipo: any) {
        this.procesoDetectado = {
            title: `${tipo.title.toUpperCase()} EN ÁMBITO ${ambito.toUpperCase()}`,
            imageSrc: tipo.imageSrc,
            bgColor: tipo.bgColor,
            bd_code: tipo.bd_code,
            ambito: ambito,
            action: tipo.action,
        };
        this.dataService.setValue('procesoDetectado', this.procesoDetectado);
    }

    defaultImage = '/assets/demo/images/logos/iconos/renovar.png';

    /**
     * Maneja el error al cargar una imagen
     * @param event Evento de error
     */
    handleImageError(event: Event): void {
        const img = event.target as HTMLImageElement;
        img.src = this.defaultImage;
        img.onerror = null;
    }

    filteredAmbitos: Ambito[] = [];

    /**
     * Filtra los ámbitos por acción seleccionada
     */
    filtrarPorAccion() {
        if (!this.seleccionAccion) {
            this.filteredAmbitos = [];
            this.resultados = [];
            return;
        }

        this.resultados = this.data.ambitos
            .flatMap((a) => a.clasificaciones.flatMap((c) => c.profesiones))
            .filter((p) => p.accion === this.seleccionAccion);

        this.filteredAmbitos = this.data.ambitos
            .map((a) => ({
                ...a,
                clasificaciones: a.clasificaciones
                    .map((c) => ({
                        ...c,
                        profesiones: c.profesiones.filter(
                            (p) => p.accion === this.seleccionAccion
                        ),
                    }))
                    .filter((c) => c.profesiones.length > 0),
            }))
            .filter((a) => a.clasificaciones.length > 0);
    }

    /**
     * Agrega una profesión al resumen
     * @param p Profesión a agregar
     */
    agregarAlResumen(p: Profesion) {
        if (!this.resumen.some((r) => r.idProfesion === p.idProfesion)) {
            this.resumen.push(p);
        }
    }

    labelIniciarTramite: string = '';

    /**
     * Maneja el click en un ámbito
     * @param ambito Ámbito seleccionado
     */
    onAmbitoClick(ambito: Ambito): void {
        this.ambitoActivoId = ambito.idAmbito;
        this.actualizarImagen(ambito.descripcionAmbito, ambito);

        for (const a of this.ambitos) {
            if (a.idAmbito !== ambito.idAmbito) {
                this.seleccionCategoria[a.idAmbito] = null;
                this.profesionesFiltradas[a.idAmbito] = [];
                this.seleccionProfesion[a.idAmbito] = null;
                this.labelIniciarTramite = '';
            }
        }
    }

    clasificacionSeleccionada: any | null = null;

    /**
     * Maneja el cambio de categoría seleccionada
     * @param ambito Ámbito actual
     */
    onCategoriaChange(ambito: Ambito): void {
        const cat = this.seleccionCategoria[ambito.idAmbito];
        if (!cat) {
            this.profesionesFiltradas[ambito.idAmbito] = [];
            this.seleccionProfesion[ambito.idAmbito] = null;
            return;
        }

        const clas = ambito.clasificaciones.find((c) => c.descripcion === cat);
        this.profesionesFiltradas[ambito.idAmbito] = clas
            ? clas.profesiones.map((p) => ({
                  ...p,
                  disabled: p.accion === 'Ninguna',
              }))
            : [];
        this.seleccionProfesion[ambito.idAmbito] = null;

        this.clasificacionSeleccionada = clas;
        this.dataService.setValue(
            'clasificacionSeleccionada',
            this.clasificacionSeleccionada
        );
    }

    accionSeleccionada: string | null = null;

    /**
     * Maneja el cambio de profesión seleccionada
     * @param profesionSeleccionada Profesión seleccionada
     * @param ambito Ámbito actual
     */
    onProfesionChange(profesionSeleccionada: any, ambito: any): void {
        this.dataService.setValue(
            'profesionSeleccionada',
            profesionSeleccionada
        );

        this.accionSeleccionada = profesionSeleccionada.accion;
        const prof = this.seleccionProfesion[ambito.idAmbito]!;
        this.labelIniciarTramite = this.titleCase(
            `${prof.descripcion} \n ${prof.accion.toUpperCase()}`
        );
    }

    /**
     * Determina si se puede iniciar un trámite
     * @returns true si se puede iniciar, false si no
     */
    get puedeIniciar(): boolean {
        const id = this.ambitoActivoId;
        return !!(id != null && this.seleccionProfesion[id]);
    }

    /**
     * Inicia un trámite
     */
    iniciarTramite(): void {
        const id = this.ambitoActivoId!;
        const prof = this.seleccionProfesion[id]!;
        const amb = this.ambitos.find((a) => a.idAmbito === id)!;

        const baseMatch = this.tiposTramite.find(
            (p) => p.code === this.accionSeleccionada?.toLowerCase()
        );

        let proceso: Proceso = {
            ambito: amb.descripcionAmbito,
            accion: this.accionSeleccionada ?? '',
            title: prof.descripcion,
            bd_code: prof.accion.toUpperCase(),
            imageSrc: `/assets/icono-${amb.descripcionAmbito.toLowerCase()}.png`,
            bgColor: 'bg-blue-600',
        };

        if (baseMatch) {
            proceso = {
                ...proceso,
                title: baseMatch.title,
                bd_code: baseMatch.bd_code,
                imageSrc: baseMatch.imageSrc,
                bgColor: baseMatch.bgColor,
            };
        }

        this.dataService.setValue('procesoDetectado', proceso);
        this.seleccionarProceso(proceso);
    }

    /**
     * Convierte un string a title case
     * @param str String a convertir
     * @returns String en title case
     */
    titleCase(str: string): string {
        return str
            .toLowerCase()
            .split(' ')
            .map((word) => {
                if (word.length === 0) return word;
                const firstChar = word[0];
                if (firstChar === '(' && word.length > 1) {
                    return '(' + word[1].toUpperCase() + word.slice(2);
                }
                return firstChar.toUpperCase() + word.slice(1);
            })
            .join(' ');
    }

    /**
     * Determina si una profesión debe estar deshabilitada
     * @param prof Profesión a evaluar
     * @returns true si debe estar deshabilitada, false si no
     */
    isDisabledProfesion = (prof: Profesion): boolean =>
        prof.accion === 'Ninguna';

    // Mapeo de imágenes por ámbito
    ambitoImages: { [key: string]: string } = {
        construcción: '/assets/demo/images/logos/iconos/construccion.png',
        ambiental: '/assets/demo/images/logos/iconos/medio_ambiente.png',
        cultural: '/assets/demo/images/logos/iconos/cultural.png',
    };

    // Mapeo de colores por ámbito
    ambitoColors: { [key: string]: string } = {
        construcción: 'bg-orange-500',
        ambiental: 'bg-green-500',
        cultural: 'bg-purple-500',
    };

    // Mapeo de títulos por ámbito
    ambitoTitles: { [key: string]: string } = {
        construcción: 'Registro de Profesionales de Construcción',
        ambiental: 'Registro de Profesionales Ambientales',
        cultural: 'Registro de Profesionales Culturales',
    };

    resetProcesoDetectado(): void {
        if (!this.ambitoActivoId) {
            this.procesoDetectado = {
                title: 'Seleccione un ámbito',
                imageSrc: this.defaultImage,
                bgColor: 'bg-gray-200',
            };
            this.labelIniciarTramite =
                'Complete los siguientes pasos para iniciar su solicitud';
        }
    }
}
